module.exports = __webpack_public_path__ + "img/9788946057371.b0d69e29.jpg";